import { FileMessage } from "#features/conversations/components/conversation-view/FileMessage.tsx";
import { TargetedReplyMessage } from "#features/conversations/components/conversation-view/TargetedReplyMessage.tsx";
import type { ConversationMessage } from "#types/types.ts";

interface Props {
    message: ConversationMessage;
}

export const ToolMessage = ({ message }: Props) => {
    switch (message.toolType) {
        case "file_upload":
            return <FileMessage message={message} />;
        case "targeted_reply":
            return <TargetedReplyMessage message={message} />;
        default:
            return null;
    }
};
